import AutocheckinPage from "../pages";


const routes = [
  {
    path: "/",
    component: AutocheckinPage,
    title: "Es la home",
    needsAuth: true,
  },
];



export default routes;
